<div class="location-display" *ngIf="location">
  <i class="location-display__icon material-icon material-icon--filled">
    place
  </i>
  <span class="location-display__text">
    {{ location.postCode }} {{ location.city }}
  </span>
</div>
